<template>
    <MainLayout title="Employee Vouchers">
        <template #content>
            <VoucherList />
        </template>
    </MainLayout>
</template>

<script>
import MainLayout from '_layouts'
import VoucherList from '_components/Tourism/VoucherList'

export default {
    components: {
        MainLayout,
        VoucherList,
    }
}
</script>